import React, { useState } from "react";
import css from "./ProductSlider6.module.css";
import ProductSliderComponent from "../ProductSliderComponent/ProductSliderComponent";
import { useOutletContext } from "react-router-dom";

const ProductSlider6: React.FC<any> = ({
  products = [],
  title,
  subtitle,
  url,
  viewAll,
}) => {
  const { toggleMiniCart } = useOutletContext<{ toggleMiniCart: () => void }>();
  const [contentLoaded, setContentLoaded] = useState(false);

  // Add validation to ensure subtitle doesn't cause layout issues
  const formattedSubtitle =
    subtitle && typeof subtitle === "string"
      ? subtitle.length > 80
        ? `${subtitle.substring(0, 77)}...`
        : subtitle
      : "";

  // Handle component mount to prevent layout shift
  React.useEffect(() => {
    // Set a small timeout to ensure the component has been laid out
    const timer = setTimeout(() => {
      setContentLoaded(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={css.container}>
      <div className={css.sliderSection}>
        <div className={css.sliderHead}>
          <div className={css.header}>
            <h2 className={css.title}>{title}</h2>
            {viewAll && (
              <a
                href={url}
                className={css.viewAllLink}
                title={`Ver todos los productos de ${title}`}
                aria-label={`Ver todos los productos en ${title}`}
              >
                Ver todo
              </a>
            )}
          </div>
          {/* Use the validated/trimmed subtitle */}
          {formattedSubtitle && (
            <h3 className={css.subtitle}>{formattedSubtitle}</h3>
          )}
        </div>

        <div
          className={css.sliderContent}
          aria-live="polite"
          aria-busy={!contentLoaded}
        >
          <ProductSliderComponent
            products={products}
            sliderItems={6}
            toggleMiniCart={toggleMiniCart} // Pass toggleMiniCart down to ProductSliderComponent
          />
        </div>
      </div>
    </div>
  );
};

export default ProductSlider6;
